<div class="form-check fn-control-label">
  <input class="form-check-input" type="radio" [value]="id" [id]="id" [name]="name" [(ngModel)]="value" (click)="clickAction($event)">
  <label class="form-check-label"  [for]="id">
    @if (label!=undefined) {
      <span [class]="labelClass" [title]="label">{{label}}</span>
    }</label>
  </div>
